export default __webpack_public_path__ + "static/media/smashkarts.4220239a.webp";